module.exports = __webpack_public_path__ + "client/img/world_03.9c9f551e.png";